// src/utils/fileValidation.js

export const validateImageFile = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        return reject("File is required.");
      }
  
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      const minSize = 15 * 1024; // 15 KB
      const maxSize = 30 * 1024; // 30 KB
  
      if (!allowedTypes.includes(file.type)) {
        return reject("Only PNG, JPG or JPEG files are allowed.");
      }
  
      if (file.size < minSize || file.size > maxSize) {
        return reject("File size must be between 15KB and 30KB.");
      }
  
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
  
      img.onload = () => {
        if (img.width !== 300 || img.height !== 100) {
          URL.revokeObjectURL(objectUrl);
          return reject("Image dimensions must be 300x100 pixels.");
        }
        URL.revokeObjectURL(objectUrl);
        return resolve("Valid");
      };
  
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        return reject("Invalid image file.");
      };
    });
  };
  